<button mat-icon-button matTooltip="Filter by Type" [matMenuTriggerFor]="menu">
  <mat-icon>filter_list</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <mat-selection-list (selectionChange)="updateSelected($event)">
    <ng-container
      *ngFor="let notificationType of filters$ | ngrxPush; trackBy: trackByType"
    >
      <mat-list-option
        checkboxPosition="before"
        [value]="notificationType"
        (click)="$event.stopPropagation()"
      >
        {{ notificationType | splitCamel | titlecase }}
      </mat-list-option>
    </ng-container>
  </mat-selection-list>
</mat-menu>
